// helpers
import { swfRelease } from './helpers/simple-workflow'
// services
import db from '@/services/db'

export default function() {
  // release variables that not in use
  this.tabs = null
  this.widgets = null
  this.widgetsData = null
  this.widgetsComputed = null
  this.customCode = null
  $('.customCssCode').remove()
  this.releaseDynamicComponentsData()
  // remove dashboard models
  window.$setDashboardModel = null
  window.$getDashboardModel = null
  window.$addDashboardModel = null
  // remove DataGrid API methods
  window.$getGrid = null
  window.$setDataGridVal = null
  window.$getDataGridVals = null
  window.$addRow = null
  window.$btnClick = null
  //localStorage.removeItem('logo')
  //localStorage.removeItem('lastDash')

  // detach events
  this.$releaseEvents()
  // release simple workflow events
  swfRelease(this.$store.state.simpleWorkflows)

  // detach firebase models
  db.getRef('widgetsData/dataGrid').off()
  db.getRef('dataGridLogs').off('child_added')
  db.getRef('tabs').off('value')
  db.getRef('widgets').off('value')
  db.getRef('widgetsData').off('value')
  if (localStorage.workspace) {
    db.ref(`access/workspaces/${localStorage.workspace}/data`).off('value')
  }
  db.getRef('tabOnLoad').off('value')
  db.getRef('privateTabs').off('value')
  db.getRef('subTabs').off('value')
  db.getRef('name').off('value')
  db.getRef('widgetsComputed').off('value')
  db.getRef('customCode').off('value')
  db.getRef('components').off('value')
  db.root.ref(`settings/${this.currentDash}`).off('value')
  db.getRef('settings').off('value')
  db.getRef('navPlacement').off('value')
  db.getRef('files').off('value')
  db.getRef('widgetsData/simpleWorkflows').off('value')

  // relese store
  this.$store.commit('clearChartComponentsSettingsShown')
  this.$store.commit('resleaseDGEditRowOpened')
  this.$store.commit('releaseDGAddControlInProcess')
  this.$store.commit('setPivotGridOptions', {})
  this.$store.commit('setCurrentTemplate', null)
  this.$store.commit('setCustomComponents', {})
  this.$store.commit('dataGrid_release')
  this.$store.commit('setSettings', {})
  this.$store.commit('setFiles', {})
  this.$store.commit('dataGrid_releaseFilterBuilders')
  this.$store.commit('toolsPanel_toggle', false)
  this.$store.commit('toolsPanel_release')
  this.$store.commit('simpleWorkflow_release')

  // clean up all the code assigned to window by DynamicRender
  window.updateWsName = null
  window.$setFBUserModel = null
  window.$setFBTrackModel = null
  window.$FBUserModel = null
  window.$getUser = null
  window.$setUser = null
  window.$getWorkspaceData = null
  window.$setFBWorkspaceData = null
  window.$sum = null
  window.$computed = null
  window.$setFBDashModel = null
  window.$FBDashModel = null
  window.$FBTrackModels = null
  window.$nflData = null
  window.$profile = null
  window.$profiles = null
  window.$sheets = null
  window.$getPivot = null
  window.getDate = null
}
